import * as React from 'react';

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
const SvgIconCheckboxUnchecked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <rect x={0.5} y={0.5} width={17} height={17} rx={2.5} stroke="currentColor" />
  </svg>
);

export default SvgIconCheckboxUnchecked;
